// extracted by mini-css-extract-plugin
export default {"slotsContainer":"cHmfpU_HunE2gYvLhlr7"};